import type { ButtonHTMLAttributes } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'ghost';
}

/** Brand button: 14px radius, sentence-case labels, one-line (truncates). */
export function Button({ variant = 'primary', className = '', type = 'button', ...rest }: ButtonProps) {
  const base =
    'inline-flex items-center justify-center gap-2 rounded-(--radius-button) px-5 py-3.5 ' +
    'font-sans text-base font-semibold whitespace-nowrap overflow-hidden text-ellipsis ' +
    'transition-[background-color,opacity] duration-(--duration-fast) ' +
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary ' +
    'disabled:opacity-50 disabled:pointer-events-none';
  const variants: Record<NonNullable<ButtonProps['variant']>, string> = {
    primary: 'bg-primary text-primary-fg active:opacity-90',
    ghost: 'bg-transparent text-fg border-[1.5px] border-border active:bg-surface-overlay',
  };
  return <button type={type} className={`${base} ${variants[variant]} ${className}`} {...rest} />;
}
